module.exports = __webpack_public_path__ + "static/mockupPhoneNew@3x-5284f9da307b3ca163a462b84df6b67b.png";